import { Component, ViewEncapsulation } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';



@Component({
  selector: 'app-about',
  templateUrl: 'about.page.html',
  styleUrls: ['about.page.scss'],
  standalone: true,
  // encapsulation: ViewEncapsulation.ShadowDom,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatToolbarModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule,
  ],
})
export class AboutPage {
  inputDisabled = false;
  connect = new FormGroup({
    name: new FormControl(''), //Validators.required),
    email: new FormControl(''), //[Validators.required,Validators.email]),
    phone: new FormControl(''),
    message: new FormControl(''), //Validators.required)
  });
  constructor(
    // private sftpService: SftpConnectService,
    private snackBar: MatSnackBar
  ) {}

  submitForm(event: Event): void {
    event.preventDefault();
    if (this.connect.valid) {
      // this.inputDisabled = true;
      // this.sftpService.sendEmail('test','msg');
      this.snackBar.open('Form Submitted', 'OK', {
        horizontalPosition: 'center', // 'start' | 'center' | 'end' | 'left' | 'right'
        verticalPosition: 'bottom', // 'top' | 'bottom'
      });
    } else {
    }
  }
}
